import { Link, useNavigate } from "react-router-dom"

const Unauthorized = () => {
    const navigate = useNavigate();

    const goBack = () => navigate(-1);

    return (
        <section>
            <h1>No access</h1>
            <br />
            <p>That page is only for editors or admins. Head back to the lounge or your recipe book.</p>
            <div className="flexGrow" style={{ gap: '0.75rem', flexWrap: 'wrap' }}>
                <button onClick={goBack}>Go Back</button>
                <Link to="/" className="login-action-btn login-action-btn--ghost">Lounge</Link>
                <Link to="/recipes" className="login-action-btn login-action-btn--accent">Recipe Book</Link>
            </div>
        </section>
    )
}

export default Unauthorized
